import { Component } from '@angular/core'
import { Title } from '@angular/platform-browser'
import { appTitles } from './app-titles'

@Component({
  selector: 'app-root',
  template: `
    <div class="container">
      <h3>Page not found</h3>
      <h1>404</h1>
    </div>
  `,
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent {

  constructor(titleService: Title) {
    titleService.setTitle(appTitles.notFound)
  }

}



// WEBPACK FOOTER //
// ./src/app/not-found.component.ts